var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrGenerados = function SvgQrGenerados(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr_generados_svg__Capa_2",
    viewBox: "0 0 14.87 13.86"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_generados_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09 13.83H4.47c-2.46 0-4.47-2-4.47-4.47V7.8h2.12v1.56c0 1.29 1.05 2.35 2.35 2.35h1.62z",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87 7.78V9.4c0 2.46-2 4.47-4.47 4.47H8.84v-2.12h1.56c1.29 0 2.35-1.05 2.35-2.35V7.78zM2.12 5.98H0V4.47C0 2 2 0 4.47 0h1.62v2.12H4.47c-1.29 0-2.35 1.05-2.35 2.35z",
    fill: "#22aa9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.83 5.98h-2.12V4.47c0-1.29-1.05-2.35-2.35-2.35H8.87V0h1.49c2.46 0 4.47 2 4.47 4.47z",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.55,
    cy: 6.89,
    r: 2.39,
    fill: "#2ad2c5"
  }))));
};
export default SvgQrGenerados;